import Tables from 'src/class/Tables';
import i18n from 'src/i18n';


const configTable = () => {
  const Table = { ...Tables.Table };
  Table.tableColumns = [
    {
      prop: 'year',
      label: i18n.t('common_words.year'),
      minWidth: 150,
      sortable: true,
      align: 'center',
    },
    {
      prop: 'type',
      label: i18n.t('fertilization.fertilizing_area'),
      minWidth: 150,
      sortable: true,
    },
    {
      prop: 'farm.name',
      label: i18n.t('common_words.farm'),
      minWidth: 150
    },
    {
      prop: 'lot.name',
      label: i18n.t('common_words.allotment'),
      minWidth: 150,
      sortable: true,
      align: 'center',
    },
    {
      prop: 'hectares',
      label: i18n.t('production.hectares'),
      minWidth: 200,
      sortable: true,
    },
    {
      prop: 'boxes_per_hectare',
      label: i18n.t('common_words.production_per_ha'),
      minWidth: 200,
      sortable: true,
      align: 'center',
    },
    {
      prop: 'area',
      label: i18n.t('common_words.area'),
      minWidth: 200
    },
  ];

  return { Table };
};

export default configTable;
